import { logger } from "common/utilities/logger";

export const safeJsonParse = (value: string) => {
  try {
    return { value: JSON.parse(value) as unknown };
  } catch (error) {
    logger.error(`[safeJsonParse] Failed to parse string as JSON: ${value}`, error);
    return undefined;
  }
};
